var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_c('Icon',{attrs:{"type":"md-arrow-dropright-circle"}}),_vm._v(" "+_vm._s(_vm.pageHeader)+" "),(_vm.pageDescr)?_c('small',[_vm._v("/ "+_vm._s(_vm.pageDescr))]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }